import style from './index.module.less'
import RoleSwitch from '@/components/ConversationHeader/RoleSwitch';
import RightSideBarMenu from '@/components/ConversationHeader/RightSideBarMenu';

function ConversationHeader () {
  return (
    <div className={style.ConversationHeader}>
      <RoleSwitch/>
      <RightSideBarMenu/>
    </div>
  )
}
export default ConversationHeader;
